/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import './style.module.scss';


// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: 'none',
  // padding: grid * 2,
  // margin: `0 ${grid}px 0 0`,

  // change background colour if dragging
  // background: isDragging ? 'lightgreen' : 'white',

  // styles we need to apply on draggables
  ...draggableStyle,
});

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? 'white' : '',
  display: 'flex',
  padding: grid,
  overflow: 'auto',
});

function AnswersType3({ answers, onChange, isAnswer, help }) {
  const [items, setItems] = useState(answers);
  const [sortItems, setSortItems] = useState([]);

  useEffect(() => {
    setItems(answers);
    setSortItems([]);
  }, [answers]);

  useEffect(() => {
    if (items.length == 0 && sortItems.length > 0) {
      onChange(sortItems);
    }
  }, [sortItems, items]);

  const onDragEnd = (result) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const tmpSortItems = [...sortItems];

    // const itemsЕ = reorder(
    //   items,
    //   result.source.index,
    //   result.destination.index
    // );

    // setItem(itemsЕ);
    if (
      result.source.droppableId == 'answers' &&
      result.destination.droppableId == 'values'
    ) {
      if (tmpSortItems.length > 0) {
        tmpSortItems.splice(
          result.destination.index,
          0,
          items[result.source.index]
        );
      } else {
        tmpSortItems.push(items[result.source.index]);
      }
      setItems(items.filter((_i, index) => index != result.source.index));
      setSortItems(tmpSortItems);
    }

    if (
      result.source.droppableId == 'values' &&
      result.destination.droppableId == 'values'
    ) {
      setSortItems(
        reorder(tmpSortItems, result.source.index, result.destination.index)
      );
    }
  };

  return (
    <div className={'AnswersType3'}>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="answers" direction="vertical">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              className={'block'}
              {...provided.droppableProps}
            >
              {items.map((item, index) => (
                <Draggable key={item._id} draggableId={item._id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                      className={'item'}
                    >
                      {item.url && <img src={item.url} />}
                      {!item.url && <div className={'title'}>{item.text}</div>}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
        {/* <div className={'text'}>{'Перетащите ответы'}</div> */}
        <Droppable droppableId="values" direction="vertical">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              style={getListStyle(snapshot.isDraggingOver)}
              {...provided.droppableProps}
              className={'block'}
            >
              {sortItems.map((item, index) => (
                <Draggable key={item._id} draggableId={item._id} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={getItemStyle(
                        snapshot.isDragging,
                        provided.draggableProps.style
                      )}
                      className={classNames('item', {
                        isCorrect: isAnswer && help && item.order == index + 1, 
                        notCorrect: isAnswer && help && item.order != index + 1
                      })}
                    >
                      {item.url && <img src={item.url} />}
                      {!item.url && <div className={'title'}>{item.text}</div>}
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
}

export default AnswersType3;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QuestionMultyView/components/Question/components/Answers/components/AnswersType3/AnswersType3.jsx